export const getDirectImageUrl = (value = "") => {
  const imageUrl = typeof value === "string" ? value.trim() : "";

  if (!imageUrl) {
    return "";
  }

  try {
    const url = new URL(imageUrl);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, "");

    if (hostname !== "github.com") {
      return imageUrl;
    }

    const pathParts = url.pathname.split("/").filter(Boolean);
    const fileViewIndex = pathParts.findIndex(
      (part) => part === "blob" || part === "raw",
    );

    if (fileViewIndex !== 2 || pathParts.length < 5) {
      return imageUrl;
    }

    const [owner, repository] = pathParts;
    const directPath = pathParts.slice(fileViewIndex + 1).join("/");

    return `https://raw.githubusercontent.com/${owner}/${repository}/${directPath}`;
  } catch {
    return imageUrl;
  }
};
